import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { FullResultsComponent } from '../../full-results.component';
import {
  ItemHeader,
  LiteratureData,
} from '@search/interfaces/search.interface';

import { EMDASH } from '@products/utils/constants/product.constants';

import { SimpleModalConfig } from '@frk/eds-components';
import { Subscription } from 'rxjs';
import {
  CartActionPerformed,
  LiteratureDocumentListingData,
  LiteratureDocumentListingState,
  ModalId,
  SegmentId,
} from '@types';

@Component({
  selector: 'ft-full-results-literature',
  templateUrl: './full-results-literature.component.html',
  styleUrls: [
    '../../full-results.component.scss',
    './full-results-literature.component.scss',
  ],
})
export class FullResultsLiteratureComponent
  extends FullResultsComponent
  implements OnChanges, OnInit, OnDestroy {
  @Input() literatureHeader: ItemHeader;
  @Input() literatureItems: object[]; // TODO set proper type
  @Input() literatureData: LiteratureData[];
  @Input() fundData: any; // TODO set proper type

  @Output() viewMoreClickedLiterature = new EventEmitter<string>();

  ModalId = ModalId; // this is to use ModaiId in component / see NGC-7598 changes
  public modalId = 'searchCartModal';
  private cartSubscription: Subscription;

  showFinra = false;
  cartItems = [];
  labelAdded: string;
  labelAdd: string;

  ngOnInit() {
    super.ngOnInit();

    this.labelAdded = this.translateService.instant('literature.Added-to-cart');
    this.labelAdd = this.translateService.instant('literature.Add-to-cart');

    // get cart state and open cart modal
    this.cartSubscription = this.cartHandlerService
      .getCartItems()
      .subscribe((item: LiteratureDocumentListingState) => {
        this.cartItems = item.cartItems.map((doc) => doc.docId);
        this.changeDetectorRef.detectChanges();
      });
  }

  /**
   * we need to pre-process data to simplify template actions
   * we will also check which literature document is in the cart
   */
  ngOnChanges() {
    // show finra column only for FA user
    // this may require refactoring after insights is implemented
    // search needs to reload config, after segment is changed
    this.showFinra = false;
    if (
      SegmentId.FINANCIAL_PROFESSIONALS === this.configService.currentSegment
    ) {
      this.showFinra = true;
    }

    this.literatureData.forEach((data: LiteratureData) => {
      data.thumbnailUrl = this.getThumbnailUrl(data.docTypeSrc);

      if ((!data.litCode || data.litCode === EMDASH) && !data.litPath) {
        data.noDownload = true;
      }

      if (!data.litCode || data.litCode === EMDASH) {
        data.noFinraLink = true;
      }

      if (
        data.orderLimit === 0 ||
        // removing this condition for now - some documents showing issue with that - comment from literature download component
        (data.isOrdItself === 'N' && !data.exemptCustomers) ||
        data.isInv === 'N'
      ) {
        data.hardcopyNotAvaliable = true;
      }
    });
  }

  openModal(modelId: string) {
    const config: SimpleModalConfig = {
      id: modelId,
      type: 'simple',
      themeTitle: 'dark',
    };
    this.modalService.open(modelId, config);
  }

  /**
   *  this may require refactoring
   * there is an issue with inheritance of Output
   * https://github.com/angular/angular/issues/5415
   *
   */
  onViewMore($tabName: string) {
    this.activeTab = $tabName;
    this.viewMoreClickedLiterature.emit($tabName);

    // TODO to verify this position after we introduce filters
    // this.clickedElemBottom = document.getElementById($event.target.id).getBoundingClientRect().top + document.documentElement.scrollTop;
  }

  /**
   *
   */
  addToCart(data: LiteratureData) {
    const cartData: LiteratureDocumentListingData = {
      literatureData: {
        docId: data.litCode !== EMDASH ? data.litCode : data.customFilePath,
      },
      product: {},
    };
    this.cartHandlerService.addToCart(
      [cartData],
      CartActionPerformed.ADDED_FROM_SEARCH
    );

    // TODO temporary solution updating label
    // needs to be refactored after literature addToCart returns value
    // TODO check if subscription updates cart items
    // this.cartItems = this.cartItems.filter((item) => item !== docId);
  }

  /**
   * deletes product from cart
   * @param docId literature code
   */
  deleteFromCart(docId: string) {
    this.cartHandlerService.removeFromCart([docId]);
    this.cartItems = this.cartItems.filter((item) => item !== docId);
  }

  /**
   *
   */
  downloadDocument(data: LiteratureData) {
    let litDownloadUrl = data.litPath;
    // analytics to be added
    if ((!data.litCode || data.litCode === EMDASH) && !data.litPath) {
      return;
    }

    if (data.litCode && data.litCode !== EMDASH) {
      litDownloadUrl = this.litDownloadUrl + data.litCode;
    }

    this.myLitratureService.downloadDocument(litDownloadUrl);
  }

  /**
   *
   */
  ngOnDestroy() {
    this.cartSubscription?.unsubscribe();
  }
}
